import colors from "../colors.js";

export default colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale-chromatic/src/categorical/Pastel1.js
// module id = 1569
// module chunks = 0